<div id="openExtendsBookingsCommission" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content" *ngIf="book != null">
      <div class="modal-header">
        <h5 class="modal-title mt-0" id="mySmallModalLabel">Comisionar reserva | <span class="bold">{{book.code}}</span>
        </h5>
      </div>
      <app-loading-modal></app-loading-modal>
      <ng-container *ngIf="book != null">
        <form validate [formGroup]="item" (ngSubmit)="preSave()" autocomplete="off">
          <div class="modal-body">
            <div class="card m-b-30 m-b-50">
              <div class="col-lg-12" *ngIf="validatealert">
                <ng-container *ngIf="moneybox != null">
                  <ng-container *ngIf="moneybox.status_closed == true || moneybox.is_before">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      Debe corregir el estado de la caja para realizar movimientos de dinero,
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!check_moneybox">
                  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                    Debe aperturar la caja para realizar movimientos de dinero,
                  </div>
                </ng-container>
              </div>
              <div class="row">
                <div class="col-lg-9">
                  <label>Colaborador<span class="required"></span>
                    <div class="book__nrodoc m-l-20" *ngIf="isCollaboratorSelected">
                      ({{collaboratorSelected.partnercompany}})
                    </div>
                  </label>
                  <ng-container *ngIf="isCollaboratorSelected">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="N° DOC: {{collaboratorSelected.document}} - {{collaboratorSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeCollaborator()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                        <!-- <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                          data-toggle="modal" data-target="#openExtendsClient"
                          (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                          <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                        </div> -->
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isCollaboratorSelected">
                    <div class="input-group input-group-grid">
                      <component-search-collaborators [classSize]="'search-small'"
                        (selectedCollaboratorsEvent)="selectedCollaboratorsSearch($event)" class="w-100">
                      </component-search-collaborators>
                      <!-- <div class="input-group-append b-0">
                        <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                          data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                          <i class="fas fa-user-plus w-100"></i>
                        </div>
                      </div> -->
                    </div>
                  </ng-container>
                </div>
                <div class="form-group col-lg-3" *ngIf="boxselected != null">
                  <label>
                    Caja seleccionada
                    <span class="required"></span>
                  </label>
                  <input type="text" disabled value="{{boxselected.description}}" class="form-control">
                  <ng-container *ngIf="check_moneybox">
                    <ng-container *ngIf="moneybox.is_before">
                      <span class="badge badge-warning f-s-11" ng-if="moneybox.is_before">CONTINÚA EN FECHA ANTERIOR :
                        {{moneybox.date_opening}}</span>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="form-group col-lg-3">
                  <label>Método de pago <span class="required"></span></label>
                  <select class="form-control" id="paymentSelected" formControlName="paymentmethod_id"
                    (change)="changePaymentMethod()" required>
                    <option *ngFor="let item of paymentmethods" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <ng-container *ngIf="paymentMethodSelected.associate_bank">
                  <div class="form-group col-lg-3">
                    <label>Cuenta origen
                      <span class="f-s-9" *ngIf="accountbanks.length == 0">( 0 registros )</span>
                      <!-- <button type="button" ng-click="addAccountBank(true)" ng-if="bankaccounts_exists == true"
                        class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                      </button> -->
                    </label>
                    <ng-container *ngIf="accountbanks.length == 0">
                      <a type="button" class="btn btn-outline-info text-white" routerLink="/{{branchofficeSlug}}/finanzas/cuentas_bancarias/lista">
                        <i class="fas fa-arrow-right m-r-5"></i>Agregar Cuenta
                      </a>
                    </ng-container>
                    <ng-container *ngIf="accountbanks.length > 0">
                      <select class="form-control" id="bankAccountSelected" (change)="changeBankAccount($event.target)">
                        <option *ngIf="!isEdit" value="null">Seleccionar cuenta</option>
                        <option *ngFor="let item of accountbanks" [value]="item.id">{{ item.concat_description}}</option>
                      </select>
                    </ng-container>
                  </div>
                  <div class="form-group col-lg-3">
                    <label>N° operación</label>
                    <input type="text" class="form-control" formControlName="reference_operation">
                  </div>
                </ng-container>
                <!-- <div class="form-group col-lg-3">
                  <label>Comisión Hotel <span class="required"></span></label>
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </span>
                    <input type="text" class="form-control bold f-s-14" id="total_hotel" numeric decimals="2"
                      onclick="click_input(this)" (keyup)="calculate_difference()" formControlName="total_hotel">
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Comisión Tours <span class="required"></span></label>
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </span>
                    <input type="text" class="form-control bold f-s-14" id="total_tour" numeric decimals="2"
                      onclick="click_input(this)" (keyup)="calculate_difference()" formControlName="total_tour">
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label class="text-center bold">TOTAL COMISIÓN</label>
                  <p class="text-primary bold m-b-0 f-s-16 text-center">
                    {{toolsService.momeySol()}}{{amount}}
                  </p>
                </div> -->
                <div class="form-group col-lg-3">
                  <label>TOTAL COMISIÓN <span class="required"></span></label>
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </span>
                    <input type="text" class="form-control bold f-s-14" id="total_tour" numeric decimals="2"
                      onclick="click_input(this)" formControlName="amount">
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Observación</label>
                  <textarea rows="2" class="form-control no-resize" formControlName="observation"></textarea>
                </div>
                <div class="form-group col-lg-6 m-t-20">
                  <label>Adjuntar constancia</label>
                  <input id="fileUrlImage" type="file" accept=".png, .jpg, .jpeg .pdf"
                    (change)="onFileSelected($event)">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer nowrap">
            <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
              (click)="close()">Cancelar</button>
            <button type="submit" class="btn btn-primary"><i class="fas fa-minus-circle m-r-3"></i>PROCESAR COMISIÓN</button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
